import { PureComponent } from 'react';

import { List } from 'immutable';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { makeSelectInProgressDevices } from '../selectors';
import RunningTable from './RunningTable';

export const columns = ['ip', 'time', 'task'];

class InProgress extends PureComponent {
  static propTypes = {
    hostnameTableDetailMsg: PropTypes.object.isRequired,
    inProgressDevices: PropTypes.instanceOf(List).isRequired,
    isLoading: PropTypes.bool.isRequired,
    isRunning: PropTypes.bool.isRequired,
    msg: PropTypes.object.isRequired,
    newSnapshot: PropTypes.bool.isRequired,
    selectedSnapshot: PropTypes.string,
    snapshotDone: PropTypes.bool,
    snapshotId: PropTypes.string,
    snapshotsMsg: PropTypes.object.isRequired,
  };

  render() {
    const {
      msg,
      inProgressDevices,
      isRunning,
      isLoading,
      newSnapshot,
      snapshotDone,
      selectedSnapshot,
      hostnameTableDetailMsg,
      snapshotId,
      snapshotsMsg,
    } = this.props;
    if (!isRunning && !isLoading && snapshotDone && newSnapshot) {
      return (
        <div className='snapshots-content__tabs-box-body'>
          <h3>{get(snapshotsMsg, 'discovery.devicesInventory.noDevices')}</h3>
          <p>{get(snapshotsMsg, 'discovery.devicesInventory.runDiscovery')}</p>
        </div>
      );
    }
    if (!isRunning && !isLoading && snapshotDone) {
      return (
        <div className='snapshots-content__tabs-box-body'>
          <h3>{get(snapshotsMsg, 'discovery.discoveryFinished')}</h3>
          <p>{get(msg, 'nothingInQueue')}</p>
        </div>
      );
    }
    if (!isRunning && !isLoading) {
      return (
        <div className='snapshots-content__tabs-box-body'>
          <h4>{get(msg, 'nothingInQueue')}</h4>
        </div>
      );
    }
    if ((isRunning || isLoading) && inProgressDevices.size === 0) {
      return (
        <div className='snapshots-content__tabs-box-body'>
          <h3>
            {isLoading
              ? get(snapshotsMsg, 'discovery.loadingSnapshot')
              : get(snapshotsMsg, 'discovery.inProgress')}
          </h3>
          <p>
            {isLoading
              ? get(msg, 'nothingInQueue')
              : get(msg, 'waitingForStats')}
          </p>
        </div>
      );
    }
    if (!newSnapshot) {
      return (
        <RunningTable
          msg={msg}
          selectedSnapshot={selectedSnapshot}
          data={inProgressDevices}
          columns={columns}
          snapshotId={snapshotId}
          hostnameTableDetailMsg={hostnameTableDetailMsg}
          tableTitle={get(msg, 'tableTitle')}
          filterable
          snapshotsMsg={snapshotsMsg}
        />
      );
    }
    return null;
  }
}

const mapStateToProps = createStructuredSelector({
  inProgressDevices: makeSelectInProgressDevices(),
});

export default connect(mapStateToProps)(InProgress);
